<script>
	import { fade } from 'svelte/transition';
	import { cookiesActivated } from '../share/stores';
	import { writeLocalStorage } from '../share/utils';

	import NavListElement from '../helpers/NavListElement.svelte';
	import ToggleButton from '../components/content/ToggleButton.svelte';

	let cookiesAllowed = false;
	let customCssCookieAllowed = false;

	function acceptedCookies() {
		if(cookiesAllowed) {
			writeLocalStorage({
				useCustomCss: customCssCookieAllowed ? true : false
			});
		}
		cookiesActivated.set(true);
	}
</script>

{#if !$cookiesActivated}
	<div class="container" transition:fade>
		<div class="text">
			<h3>Krümelmonster</h3>
			<p class="balance">Unsere Website nutzt Cookies – kleine Kekse, die in deinem Browser lokal auf Ihrem Computer abgespeichert
				werden und die Funktion unserer Seite unterstützen. Einige der Kekse sind für dein Erlebnis hier ohnehin notwendig und können daher nicht abgelehnt werden. Andere Kekse - z.B. Geschmacksrichtungen »Google«, »Facebook« oder »Werbepartner« - kannst du aber sehr wohl ablehnen. Mit der Zustimmung stimmst du auch unseren Datenschutzbedingungen zu und nimmst zur Kenntnis, dass alle auf der Webseite befindlichen Formulare, die du ausfüllst und absendest auch elektronisch verarbeitet werden.</p>
			<div class="actions">
				<span class="toggles">
					<p>
						<ToggleButton active={cookiesAllowed} on:click={() => cookiesAllowed = !cookiesAllowed}/>
						Statistiken
					</p>
					<p>
						<ToggleButton active={customCssCookieAllowed} on:click={() => customCssCookieAllowed = !customCssCookieAllowed}/>
						Marketing
					</p>
				</span>
				<ul>
					<NavListElement url="/impressum" text="Impressum"/>
					<NavListElement url="/datenschutz" text="Datenschutz"/>
				</ul>
				<button
					on:click={() => {cookiesAllowed = true; customCssCookieAllowed = true}}
					on:click={() => {setTimeout(() => acceptedCookies(), 200)}}>
					ALLE – PASST FÜR MICH
				</button>
				<button on:click={acceptedCookies}>
					INDIVIDUELLE MISCHUNG
				</button>
			</div>
		</div>
		<div class="cookie_gap"></div>
		<div class="cookies">
			<img src="/img/global/cookies/cookies.webp">
		</div>
	</div>
{/if}


<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	.container {
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		display: grid;
		grid-template-columns: auto;
		background: white;
		--toggle-color: white;
		--toggle-background-color: black;
		--toggle-background-color-active: var(--color-burgeins-6);
		--button-height: 2.5rem;
		--toggle-distance: 2px;

		@include for-tablet-landscape-up {
			grid-template-columns: 7fr .5fr 1fr;
			gap: 15px;
		}

		.cookies {
			height: 0;
			position: absolute;
			width: 15vw;
			right: 0;

			@include for-tablet-landscape-up {
				position: relative;
				width: auto;
			}

			img {
				position: relative;
				width: 200%;
				transform: translateY(-50%) translateX(-25%);

				@include for-tablet-landscape-up {
					transform: translateY(-25%) translateX(-25%);
				}
			}
		}
		.text, .actions {
			:global(a), :global(li), :global(p) {
				@include font-px-to-rem(18, 28, 400);
			}
		}
		.text {
			padding: 3rem;
			display: grid;

			grid-template-rows: auto 1fr auto;
			grid-auto-flow: column;
			grid-row-gap: 2rem;

			@include for-tablet-landscape-up {
				grid-template-rows: auto;
				grid-auto-flow: row;
				grid-template-columns: 4fr 3fr;
				grid-column-gap: 5em;
				grid-row-gap: unset;
			}

			h3 {
				grid-column-start: 1;
				grid-column-end: 3;
			}
		}
		.actions {
			display: grid;
			grid-template-columns: 1fr 1fr;
			align-content: space-between;
			gap: px-to-em(29);

			.toggles {
				display: flex;
				flex-direction: column;
				gap: px-to-em(20);

				p {
					display: flex;
					align-items: center;
					gap: px-to-em(20);
				}
			}

			ul {
				list-style-type: none;

				:global(li) {
					text-decoration: underline;
				}
			}

			button {
				border-radius: 5px;
				padding: 1rem 3rem;
				background: var(--color-burgeins-6) 0% 0% no-repeat padding-box;
				color: white;
			}
		}
	}
</style>
